import { formatMoney } from "@shopify/theme-currency";

function resetChecked(button) {
  button.removeAttribute("checked");
}

function remakeImgSrc(currImgSrc, variantImgSrc) {
  const string = currImgSrc;
  const delimiter = "/";
  const start = 5;
  const pieces = currImgSrc.split(delimiter).slice(0, start);
  const linkPart1 = pieces.join(delimiter);
  const linkPart2 = currImgSrc.split("?")[1];

  return linkPart1 + "/" + variantImgSrc + "?" + linkPart2;
}

document.addEventListener("DOMContentLoaded", function () {
  const url = window.location.pathname;
  const isCollectionsPage = url.includes("/collections/");

  if (isCollectionsPage) {
    const productCards = document.querySelectorAll(
      ".card--product-with-add-to-cart",
    );

    for (let i = 0; i < productCards.length; i++) {
      // Handle img swap on hover
      const productCardImageWrapper = productCards[i].querySelector(
        ".card__image-wrapper",
      );

      if (productCards[i].querySelector(".card__product-image.hover-image")) {
        productCardImageWrapper.addEventListener("mouseover", (e) => {
          productCards[i].querySelector(
            ".card__product-image.hover-image",
          ).style.zIndex = 2;
        });

        productCardImageWrapper.addEventListener("mouseout", (e) => {
          productCards[i].querySelector(
            ".card__product-image.hover-image",
          ).style.zIndex = -1;
        });
      }

      // Handle variant scroller
      if (productCards[i].querySelector(".variants-scroller")) {
        const productCardMainImage =
          productCards[i].querySelectorAll("picture")[1];

        const productCardPriceDisplay =
          productCards[i].querySelector(".card__price");

        const productCardAddToCartBtn = productCards[i].querySelector(
          ".card__product-add-to-cart",
        );

        const productCardAddToCartBtnText = productCardAddToCartBtn.textContent;

        // Handle variant display
        const productCardWidth = productCards[i].offsetWidth;

        const optionsWrap = productCards[i].querySelector(
          ".variants-container__options-wrap",
        );
        const optionsWrapWidth = optionsWrap.offsetWidth;

        if (optionsWrapWidth > productCardWidth) {
          const scrollControls =
            productCards[i].querySelectorAll(".variant-scroll");

          scrollControls.forEach((control) => {
            control.style.display = "block";
          });

          optionsWrap.style.padding = "0 28px";
        }

        const leftControl = productCards[i].querySelector(".scroll-left");
        const rightControl = productCards[i].querySelector(".scroll-right");

        leftControl.addEventListener("click", (e) => {
          e.currentTarget.parentNode.querySelector(
            ".variants-container",
          ).scrollLeft -= 150;
        });
        rightControl.addEventListener("click", (e) => {
          e.currentTarget.parentNode.querySelector(
            ".variants-container",
          ).scrollLeft += 150;
        });

        // Handle variant buttons
        const variantButtons = productCards[i].querySelectorAll(
          'input[type="radio"]',
        );

        const variantPrice =
          variantButtons[0].getAttribute("data-option-price");

        // Update Add to Cart button text
        productCardAddToCartBtn.textContent =
          productCardAddToCartBtnText + `\u2014 ${formatMoney(variantPrice)}`;

        for (let i = 0; i < variantButtons.length; i++) {
          variantButtons[i].addEventListener("click", (e) => {
            variantButtons.forEach((button) => {
              resetChecked(button);
            });
            e.currentTarget.setAttribute("checked", "true");

            const variantPrice =
              e.currentTarget.getAttribute("data-option-price");
            const variantImage =
              e.currentTarget.getAttribute("data-option-image");
            const variantId = e.currentTarget.getAttribute("data-option-variant-id")

            // Update Add to Cart button text
            productCardAddToCartBtn.textContent =
              productCardAddToCartBtnText +
              `\u2014 ${formatMoney(variantPrice)}`;

            productCardAddToCartBtn.setAttribute('data-product-variant-id', variantId)

            // Update image
            const currentImgSrc = productCardMainImage
              .querySelector("img")
              .getAttribute("src");
            const newImgSrc = remakeImgSrc(currentImgSrc, variantImage);
            productCardMainImage
              .querySelector("source")
              .setAttribute("srcset", newImgSrc);
            productCardMainImage
              .querySelector("img")
              .setAttribute("srcset", newImgSrc);
            productCardMainImage
              .querySelector("img")
              .setAttribute("src", newImgSrc);
            productCardMainImage
              .querySelector("img")
              .setAttribute("data-zoom", newImgSrc);
          });
        }
      }
    }
  }
});
